"use client";

import { FormEvent, useState } from "react";
import { useSearchParams } from "next/navigation";

export function AccessForm() {
  const searchParams = useSearchParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setLoading(true);
    setError("");
    const response = await fetch("/api/access", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ password }),
    });
    if (!response.ok) {
      setError("Incorrect password. Please try again.");
      setLoading(false);
      return;
    }
    const requested = searchParams.get("returnTo");
    const destination = requested?.startsWith("/") && !requested.startsWith("//")
      ? requested
      : "/";
    // A full navigation guarantees the newly issued HttpOnly cookie is present
    // before the access proxy evaluates the destination.
    window.location.replace(destination);
  }

  return (
    <form onSubmit={submit} className="mt-8 space-y-4">
      <label className="block text-left text-sm font-medium text-white/80" htmlFor="site-password">
        Access password
      </label>
      <input
        id="site-password"
        autoFocus
        autoComplete="current-password"
        type="password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        className="h-12 w-full rounded-xl border border-white/15 bg-white/5 px-4 text-base text-white outline-none transition focus:border-violet-400 focus:ring-2 focus:ring-violet-400/20"
        placeholder="Enter password"
      />
      {error ? <p className="text-left text-sm text-red-300">{error}</p> : null}
      <button
        type="submit"
        disabled={loading || !password}
        className="h-12 w-full rounded-xl bg-white text-sm font-semibold text-black transition hover:bg-white/90 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {loading ? "Checking…" : "Enter EasyShot"}
      </button>
    </form>
  );
}
